import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import VerifyRecipientContent from "components/pages/AdvancedAlertsPage/components/VerifyRecipientContent";
import Classes, { Account } from "model";

export default function CaptureNotifiLegacyVerifyRecipientEntered(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const account = Account.getDefaultBrandedAccountByType("checking");
    const dataObj = { recipient: "(555) 987-6543", verificationCode: "6378814" };
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    // Sets the component to be used for the content
    .update([ "contentData" ], dataObj)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], VerifyRecipientContent)
    .submit();
    
    return <AdvancedAlertsPage data={ data } ui={ ui } />
}